import { useState, useEffect, useCallback, useMemo } from 'react';

export const useResponsiveBreakPoints = () => {
  const win = typeof window !== 'undefined' && window;
  const mounted = useSkipInitialRender();
  const [width, setWidth] = useState(win ? win.innerWidth : 0);
  const handleWindowSizeChange = useCallback(() => (win ? setWidth(win?.innerWidth) : null), [win]);
  useEffect(() => {
    if (!win) return;
    win?.addEventListener('resize', handleWindowSizeChange);
    return () => {
      win?.removeEventListener('resize', handleWindowSizeChange);
    };
  }, [handleWindowSizeChange, win]);
  return {
    isDesktop: mounted ? (win ? width >= 1024 : false) : false,
    isLargeDesktop: mounted ? (win ? width >= 1280 : false) : false,
    isTablet: mounted ? (win ? width >= 768 && width < 1024 : false) : false,
    isMobile: mounted ? (win ? width < 768 : false) : false,
    isSmallMobile: mounted ? (win ? width < 640 : false) : false,
    isExtraSmallMobile: mounted ? (win ? width <= 412 : false) : false,
  };
};
const useSkipInitialRender = () => {
  const [isSkipped, setIsSkipped] = useState(false);
  useEffect(() => {
    setIsSkipped(true);
    return () => {
      setIsSkipped(false);
    };
  }, []);
  return useMemo(() => isSkipped, [isSkipped]);
};
